<div class="logo">
  <a [routerLink]="[routes.dashboard]">
    <img width="146" src="/assets/logo-dashboard.svg" alt="Logo" class="logo-img" />
  </a>
</div>

<p-menu [model]="items"></p-menu>
